/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Obligations_S41_Item_1Inputs */

const es_tyc_obligations_s41_item_1 = /** @type {(inputs: Tyc_Obligations_S41_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceder, buscar y recuperar datos de sus Fuentes Conectadas autorizadas.`)
};

const en_tyc_obligations_s41_item_1 = /** @type {(inputs: Tyc_Obligations_S41_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access, search, and retrieve data from your authorized Connected Sources.`)
};

/**
* | output |
* | --- |
* | "Access, search, and retrieve data from your authorized Connected Sources." |
*
* @param {Tyc_Obligations_S41_Item_1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_obligations_s41_item_1 = /** @type {((inputs?: Tyc_Obligations_S41_Item_1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Obligations_S41_Item_1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_obligations_s41_item_1(inputs)
	return en_tyc_obligations_s41_item_1(inputs)
});
export { tyc_obligations_s41_item_1 as "tyc.obligations.s41_item_1" }